import { useMembers } from 'chat/members/queries/list'
import { ReadersScreenProps } from 'home/stack/types'
import React from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { useReaders } from './queries/list'
import { ReadersView } from './view'

export function ReadersScreen({ route }: ReadersScreenProps) {
  const { conversationId, messageId } = route.params
  const readersQuery = useReaders(conversationId, messageId)
  const membersQuery = useMembers(conversationId)
  const memberCount = membersQuery.data?.length

  return (
    <StatusBoundary
      isLoading={readersQuery.isLoading || membersQuery.isLoading}
      error={readersQuery.isError}
    >
      <ReadersView readers={readersQuery.data} memberCount={memberCount} />
    </StatusBoundary>
  )
}
